import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'
import { gql } from '@apollo/client'
import { useQuery } from '@apollo/client/react'

import { NotFound } from 'js/core/NotFound'

import AddEditForm from './AddEditForm'
import pollDetailFragment from './fragments/detailFragment'
import { POLLS_ITEM } from './Item'
import { POLLS_LIST } from './List'

const Edit = () => {
    const { t } = useTranslation()
    const { guid } = useParams()

    const { loading, data } = useQuery(POLLS_EDIT, {
        variables: {
            guid,
        },
    })

    if (loading) {
        return null
    }

    const { entity } = data || {}

    if (!entity || !entity?.canEdit) {
        return <NotFound />
    }

    const refetchQueries = [POLLS_LIST, POLLS_ITEM]

    return (
        <AddEditForm
            title={t('entity-poll.edit')}
            entity={entity}
            refetchQueries={refetchQueries}
        />
    )
}

const POLLS_EDIT = gql`
    query PollsEdit($guid: String!) {
        entity(guid: $guid) {
            guid
            ...PollDetailFragment
        }
    }
    ${pollDetailFragment}
`

export default Edit
